import React from 'react';
import { InlineGrid } from '@marvelapp/marvel-ui/grid';
import Link from 'gatsby-link';
import MarvelLink from '@marvelapp/marvel-ui/link';
import HeaderLogo from '../../Header/HeaderLogo';
import generalStyles from './style/general.module.css';

export default function DevLogo() {
  return (
    <div className={generalStyles.logo}>
      <InlineGrid size="xs">
        <HeaderLogo isLight />
        <InlineGrid size="xs">
          <div className={generalStyles.line} />
          <Link to="/developers/">
            <MarvelLink hasUnderline={false}>
              <div className={generalStyles.developers}>Developers</div>
            </MarvelLink>
          </Link>
        </InlineGrid>
      </InlineGrid>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/modules/DevHeader/DevLogo/index.js